<app-entity-edit [entityEditBaseComponent]="this"
                        displayKey="name">
</app-entity-edit>
